export const calculateTextingRatio = (
  newSubscriptionsRevenue: number,
  messageRevenue: number,
  tipsRevenue: number,
) => {
  const ratio =
    newSubscriptionsRevenue <= 0
      ? 0
      : (messageRevenue + tipsRevenue) / newSubscriptionsRevenue

  return ratio.toFixed(2)
}

export const calculateConversionRate = (
  linkClicks: number,
  newSubscriptions: number,
) => {
  const rate = linkClicks <= 0 ? 0 : (100 / linkClicks) * newSubscriptions

  return rate.toFixed(2) + '%'
}
